import React from "react";
import { Box, Typography } from "@mui/material";

const SectionHeader = ({ eyebrow, title, description, align = "left" }) => (
  <Box
    sx={{
      maxWidth: align === "center" ? 860 : 760,
      mx: align === "center" ? "auto" : 0,
      textAlign: align,
      mb: { xs: 4.5, md: 5.5, lg: 6.25 },
    }}
  >
    {eyebrow ? (
      <Box
        className="eyebrow"
        sx={{
          justifyContent: align === "center" ? "center" : "flex-start",
        }}
      >
        {eyebrow}
      </Box>
    ) : null}
    <Typography
      variant="h2"
      sx={{
        mt: eyebrow ? 1.4 : 0,
        maxWidth: align === "center" ? 820 : 700,
        mx: align === "center" ? "auto" : 0,
      }}
    >
      {title}
    </Typography>
    {description ? (
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{
          mt: 2.15,
          maxWidth: align === "center" ? 740 : 680,
          mx: align === "center" ? "auto" : 0,
        }}
      >
        {description}
      </Typography>
    ) : null}
  </Box>
);

export default SectionHeader;
